import {Model, ModelMixin} from '../../../../domain/model/common/model.class';
import {ContactInfo} from '../../../../domain/model/profile/contact-info.model';
import {PracticeSpecialtiesInfo} from '../../../../domain/model/profile/practice-specialties-info.model';
import {User} from '../../../../domain/model/user/user.model';
/**
 * Created by Rodrigo Quesada on 20/03/17.
 */
export class UserSearchModel extends ModelMixin() implements Model<UserSearchModel> {

    TYPE = UserSearchModel;

    userInfo: User = new User();
    practiceSpecialtiesInfo: PracticeSpecialtiesInfo = new PracticeSpecialtiesInfo();
    contactInfo: ContactInfo = new ContactInfo();
    npi: string;
    statesLicensed: string[];

    constructor(jsonData: any = {}) {
        super();
        this.userInfo = new User(jsonData.userInfo);
        this.practiceSpecialtiesInfo = new PracticeSpecialtiesInfo(jsonData.practiceSpecialtiesInfo);
        this.contactInfo = new ContactInfo(jsonData.contactInfo);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/search/model/user-search.model.ts